/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 666TdydnqTmUJpihDvjWrt
// Component: KIALDnHqraz9

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 666TdydnqTmUJpihDvjWrt/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 666TdydnqTmUJpihDvjWrt/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicCard.module.css"; // plasmic-import: KIALDnHqraz9/css

import FrameIcon from "./icons/PlasmicIcon__Frame"; // plasmic-import: 4gN0eEO49Ni3/icon
import Icon6Icon from "./icons/PlasmicIcon__Icon6"; // plasmic-import: V1Z2Lvtq2PbD/icon
import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: up-9MMw2XjrH/icon

createPlasmicElementProxy;

export type PlasmicCard__VariantMembers = {};
export type PlasmicCard__VariantsArgs = {};
type VariantPropType = keyof PlasmicCard__VariantsArgs;
export const PlasmicCard__VariantProps = new Array<VariantPropType>();

export type PlasmicCard__ArgsType = {
  tiile?: string;
  priceMin?: string;
  imageLink?: string;
  attributes?: any;
  onClick?: () => void;
};
type ArgPropType = keyof PlasmicCard__ArgsType;
export const PlasmicCard__ArgProps = new Array<ArgPropType>(
  "tiile",
  "priceMin",
  "imageLink",
  "attributes",
  "onClick"
);

export type PlasmicCard__OverridesType = {
  root?: Flex__<"div">;
  appleWatchSeries1046Mm7?: Flex__<"div">;
  img?: Flex__<typeof PlasmicImg__>;
  a41?: Flex__<"div">;
  a42?: Flex__<"div">;
  ماندگاری۱۲تا۱۸ماهه?: Flex__<"div">;
  a43?: Flex__<"div">;
};

export interface DefaultCardProps {
  tiile?: string;
  priceMin?: string;
  imageLink?: string;
  attributes?: any;
  onClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch { }
  return undefined;
}

function PlasmicCard__RenderFunc(props: {
  variants: PlasmicCard__VariantsArgs;
  args: PlasmicCard__ArgsType;
  overrides: PlasmicCard__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          tiile:
            "\u062a\u0632\u0631\u06cc\u06cc\u0642 \u0641\u06cc\u0644\u0631",
          priceMin: "\u06f6\u06f0\u06f0,\u06f0\u06f0\u06f0\u2028"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_666TdydnqTmUJpihDvjWrt",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      onClick={async event => {
        const $steps = {};

        $steps["runOnClick"] = true
          ? (() => {
            const actionArgs = { eventRef: $props["onClick"] };
            return (({ eventRef, args }) => {
              return eventRef?.(...(args ?? []));
            })?.apply(null, [actionArgs]);
          })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
    >
      <div
        data-plasmic-name={"appleWatchSeries1046Mm7"}
        data-plasmic-override={overrides.appleWatchSeries1046Mm7}
        className={classNames("all", sty.appleWatchSeries1046Mm7)}
      >
        {(() => {
          try {
            return !!$props.imageLink;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"153px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            loading={"lazy"}
            src={(() => {
              try {
                return $props.imageLink;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "https://khedmat.s3.ir-thr-at1.arvanstorage.ir/nothing_2K_2026051552221.jpeg?versionId=";
                }
                throw e;
              }
            })()}
          />
        ) : null}
        <div
          data-plasmic-name={"a41"}
          data-plasmic-override={overrides.a41}
          className={classNames("all", sty.a41)}
        >
          <div className={classNames("all", "__wab_text", sty.text__jitqe)}>
            <React.Fragment>
              {(() => {
                try {
                  return $props.tiile;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "\u062a\u0632\u0631\u06cc\u0642 \u0641\u06cc\u0644\u0631";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        </div>
        {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
          (() => {
            try {
              return $props.attributes;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return [];
              }
              throw e;
            }
          })()
        ).map((__plasmic_item_0, __plasmic_idx_0) => {
          const currentItem = __plasmic_item_0;
          const currentIndex = __plasmic_idx_0;
          return (
            <div
              data-plasmic-name={"a42"}
              data-plasmic-override={overrides.a42}
              className={classNames("all", sty.a42)}
              key={currentIndex}
            >
              <FrameIcon
                className={classNames("all", sty.svg___4FnB3)}
                role={"img"}
              />

              <div
                data-plasmic-name={
                  "\u0645\u0627\u0646\u062f\u06af\u0627\u0631\u06cc\u06f1\u06f2\u062a\u0627\u06f1\u06f8\u0645\u0627\u0647\u0647"
                }
                data-plasmic-override={overrides.ماندگاری۱۲تا۱۸ماهه}
                className={classNames(
                  "all",
                  "__wab_text",
                  sty.ماندگاری۱۲تا۱۸ماهه
                )}
              >
                <React.Fragment>
                  {(() => {
                    try {
                      return currentItem;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "\u0645\u0627\u0646\u062f\u06af\u0627\u0631\u06cc \u06f1\u06f2 \u062a\u0627 \u06f1\u06f8 \u0645\u0627\u0647\u0647\n";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              </div>
            </div>
          );
        })}
      </div>
      <div className={classNames("all", sty.freeBox__c9ThG)}>
        <div
          data-plasmic-name={"a43"}
          data-plasmic-override={overrides.a43}
          className={classNames("all", sty.a43)}
        >
          <div className={classNames("all", "__wab_text", sty.text__lEfIe)}>
            <React.Fragment>
              {(() => {
                try {
                  return $props.priceMin;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "\u06f6\u06f0\u06f0,\u06f0\u06f0\u06f0\u2028";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
          <Icon6Icon
            className={classNames("all", sty.svg__n8AAq)}
            role={"img"}
          />
        </div>
        <div className={classNames("all", sty.freeBox__mg4Fq)}>
          <div className={classNames("all", "__wab_text", sty.text___6Oeo6)}>
            {args.buttonText ?? "\u062f\u0631\u06cc\u0627\u0641\u062a \u0646\u0648\u0628\u062a"}
          </div>
          <Icon5Icon
            className={classNames("all", sty.svg__sx0Ov)}
            role={"img"}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "appleWatchSeries1046Mm7",
    "img",
    "a41",
    "a42",
    "\u0645\u0627\u0646\u062f\u06af\u0627\u0631\u06cc\u06f1\u06f2\u062a\u0627\u06f1\u06f8\u0645\u0627\u0647\u0647",
    "a43"
  ],
  appleWatchSeries1046Mm7: [
    "appleWatchSeries1046Mm7",
    "img",
    "a41",
    "a42",
    "\u0645\u0627\u0646\u062f\u06af\u0627\u0631\u06cc\u06f1\u06f2\u062a\u0627\u06f1\u06f8\u0645\u0627\u0647\u0647"
  ],
  img: ["img"],
  a41: ["a41"],
  a42: [
    "a42",
    "\u0645\u0627\u0646\u062f\u06af\u0627\u0631\u06cc\u06f1\u06f2\u062a\u0627\u06f1\u06f8\u0645\u0627\u0647\u0647"
  ],
  ماندگاری۱۲تا۱۸ماهه: [
    "\u0645\u0627\u0646\u062f\u06af\u0627\u0631\u06cc\u06f1\u06f2\u062a\u0627\u06f1\u06f8\u0645\u0627\u0647\u0647"
  ],
  a43: ["a43"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  appleWatchSeries1046Mm7: "div";
  img: typeof PlasmicImg__;
  a41: "div";
  a42: "div";
  ماندگاری۱۲تا۱۸ماهه: "div";
  a43: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCard__VariantsArgs;
    args?: PlasmicCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
  // Specify variants directly as props
  Omit<PlasmicCard__VariantsArgs, ReservedPropsType> &
  // Specify args directly as props
  Omit<PlasmicCard__ArgsType, ReservedPropsType> &
  // Specify overrides for each element directly as props
  Omit<
    NodeOverridesType<T>,
    ReservedPropsType | VariantPropType | ArgPropType
  > &
  // Specify props for the root element
  Omit<
    Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
    ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
  >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCard__ArgProps,
          internalVariantPropNames: PlasmicCard__VariantProps
        }),
      [props, nodeName]
    );
    if ((props as any).buttonText !== undefined) {
      args.buttonText = (props as any).buttonText;
    }
    return PlasmicCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCard";
  } else {
    func.displayName = `PlasmicCard.${nodeName}`;
  }
  return func;
}

export const PlasmicCard = Object.assign(
  // Top-level PlasmicCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    appleWatchSeries1046Mm7: makeNodeComponent("appleWatchSeries1046Mm7"),
    img: makeNodeComponent("img"),
    a41: makeNodeComponent("a41"),
    a42: makeNodeComponent("a42"),
    ماندگاری۱۲تا۱۸ماهه: makeNodeComponent(
      "\u0645\u0627\u0646\u062f\u06af\u0627\u0631\u06cc\u06f1\u06f2\u062a\u0627\u06f1\u06f8\u0645\u0627\u0647\u0647"
    ),
    a43: makeNodeComponent("a43"),

    // Metadata about props expected for PlasmicCard
    internalVariantProps: PlasmicCard__VariantProps,
    internalArgProps: PlasmicCard__ArgProps
  }
);

export default PlasmicCard;
/* prettier-ignore-end */
